import useTranslator from "../../hooks/useTranslator";
import { useNavigate, useParams } from "react-router-dom";
import { convertCurrencyFormat, haveValue } from "../../helper/common";
import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";
import { Icon, Modal, OptionCard } from "../design";

const LinkedTenantsProperties = ({
  propertiesData,
  showPropertiesPopup,
  setShowPropertiesPopup,
}) => {
  const { _t } = useTranslator();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { workspaceId } = useParams();

  return (
    <Modal
      open={Boolean(showPropertiesPopup)}
      onClose={() => setShowPropertiesPopup(false)}
      title={_t("tenantLinkedProperties")}
      closeLabel={_t("close")}
      align="start"
    >
      <div className="ds-option-list">
        {propertiesData?.map((property) => {
          const propertyName = `${property?.street} - ${
            Number.isNaN(parseInt(property?.street_number, 10))
              ? "N/A"
              : String(parseInt(property?.street_number, 10))
          }, ${property?.floor_number}${
            property?.flat_number ? ` - ${property?.flat_number}` : ""
          }`;
          return (
            <OptionCard
              key={property?._id}
              icon={<Icon name="building" />}
              title={propertyName}
              aside={
                haveValue(property?.report_rent)
                  ? `€${convertCurrencyFormat(property.report_rent)} / ${_t(
                      "perMonth"
                    )}`
                  : null
              }
              onClick={() =>
                navigate(
                  user?.role === "landlord" && haveValue(workspaceId)
                    ? `/${workspaceId}/home?propertyId=${property?._id}&propName=${propertyName}`
                    : `/home?propertyId=${property?._id}&propName=${propertyName}`
                )
              }
            />
          );
        })}
      </div>
    </Modal>
  );
};

export default LinkedTenantsProperties;
